module.exports = __webpack_public_path__ + "static/img/t15.b6198646.png";